
import React, { useEffect } from "react";
import {
    Table,
    Card,
    Button,
    Space,
    Form,
    Input,
    Row,
    Col
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useState } from "react";
import { ZoomInOutlined, PhoneOutlined, PhoneFilled } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import RenewalCalls from "./RenewalCalls";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { usePersistedStore } from "../../store/persisted-store";
import CrmCallHistoryModal from "../user-business-report/crmReport/crmCallHistory/CrmCallHistoryModal";

export default function BusinessRenewalReport() {
    const reports = useReportsStore()
    const general = useGeneralStore();
    const { business } = usePersistedStore();
    const data = reports.renewalReport.data.Items;
    const loading = reports.renewalReport.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const [InsuranceRequestId, setInsuranceRequestId] = useState();
    const [applicantUserId, setApplicantUserId] = useState();

    const [searchValue, setSearchValue] = useState("");
    const [filterData, setFilterData] = useState([]);
    useEffect(() => {
        if (token)
            reports.getBusinessRenewalReport();
    }, [token])

    useEffect(() => {
        setFilterData(data)
    }, [data]);

    function handlePaste(event) {
        let paste = (event.clipboardData || window.clipboardData).getData("text");
        paste = paste.split("|").join(",");
        setSearchValue(paste)
    }

    const keysArray = Array.from({ length: filterData?.length }, (_, index) => `key-${index}`);

    useEffect(() => {
        if (searchValue === "") return setFilterData(data)
    }, [searchValue]);
    const searchHandlerInput = (event) => {
        const { value } = event.target;
        setSearchValue(value);
        if (value) {
            const filtered = data && data?.filter((item) => {
                return item.ApplicantFullName.includes(value) ||
                    item.BranchTitle.includes(value) ||
                    item.CompanyName.includes(value) ||
                    item.StatusTitle.includes(value) ||
                    item.PolicyOwnerFullName.includes(value) ||
                    item.InsuranceRequestId.toString().includes(value) ||
                    item.Username.includes(Number(value))
            }
            )
            if (filtered) setFilterData(filtered)
        }
    }
    const columns = [
        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 75,
            render: (_, record) =>
                data?.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setInsuranceRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "تماس",
            dataIndex: "callOperation",
            key: "callOperation",
            width: 10,
            render: (_, record) =>
                data?.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getCrmCalls(record.InsuranceRequestId);
                            setInsuranceRequestId(record.InsuranceRequestId);
                            setApplicantUserId(record.ApplicantUserId);
                            general.ToggleRenewalCallModal();
                        }
                        }><PhoneOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "تماس جدید",
            dataIndex: "newCall",
            key: "newCall",
            width: 10,
            render: (_, record) =>
                data?.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            setInsuranceRequestId(record.InsuranceRequestId);
                            setApplicantUserId(record.ApplicantUserId);
                            general.ToggleCrmCallHistoryModal()
                        }
                        }><PhoneFilled /></Button>
                    </Space>
                ),
        },
        {
            title: "تعداد تماس",
            dataIndex: "CallCount",
            key: "CallCount",
            width: 100,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.CallCount ? (first = a.CallCount) : (first = "");
                b.CallCount ? (second = b.CallCount) : (second = "");
                return first.localeCompare(second);
            },
        },
        {
            title: "نام  کاربر",
            dataIndex: "ApplicantFullName",
            key: "ApplicantFullName",
            width: 120,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
                b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "نام رشته",
            dataIndex: "BranchTitle",
            key: "BranchTitle",
            width: 110,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.BranchTitle ? (first = a.BranchTitle) : (first = "");
                b.BranchTitle ? (second = b.BranchTitle) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "تاریخ خرید",
            dataIndex: "BuyDate",
            key: "BuyDate",
            width: 110,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.BuyDate ? first = a.BuyDate : first = '';
                b.BuyDate ? second = b.BuyDate : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data?.BuyDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "تاریخ صدور",
            dataIndex: "IssuanceDate",
            key: "IssuanceDate",
            width: 110,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.IssuanceDate ? first = a.IssuanceDate : first = '';
                b.IssuanceDate ? second = b.IssuanceDate : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data?.IssuanceDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "نام شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.CompanyName ? (first = a.CompanyName) : (first = "");
                b.CompanyName ? (second = b.CompanyName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "کد درخواست",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            sorter: (a, b) => a.InsuranceRequestId - b.InsuranceRequestId,
            width: 90,
        },
        {
            title: "نام بیمه گزار",
            dataIndex: "PolicyOwnerFullName",
            key: "PolicyOwnerFullName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PolicyOwnerFullName ? (first = a.PolicyOwnerFullName) : (first = "");
                b.PolicyOwnerFullName ? (second = b.PolicyOwnerFullName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "نام کاربری",
            dataIndex: "Username",
            key: "Username",
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.Username ? (first = a.Username) : (first = "");
                b.Username ? (second = b.Username) : (second = "");
                return first.localeCompare(second);
            },
            width: 110,
        },


    ];

    return (
        <Card>
            <Row>
                <Col span={18}>
                    <Form.Item
                        onKeyPress={(e) => (e.key === 'Enter' && "")}
                        name="search" label="جست و جو:"
                        className="search-lable">
                        <Input
                            value={searchValue}
                            onPaste={handlePaste}
                            onChange={e => searchHandlerInput(e)}
                            className="table-search"
                            placeholder="   بر اساس نام کاربر، نام رشته،نام شرکت بیمه، کد درخواست، نام بیمه گزار، وضعیت درخواست ، نام کاربری"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <button type="primary" className="btn btn-primary waves-effect waves-light float-left" htmltype="submit"
                        onClick={() => reports.getBusinessRenewalReport()} style={{ marginBottom: "20px" }}>
                        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>                    </button>
                </Col>
            </Row>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                pagination={true}
                columns={columns}
                loading={loading}
                rowKey="InsuranceRequestId"
                scroll={true}
                dataSource={filterData}
            />
            <InsuranceDetails requestId={InsuranceRequestId} />
            <RenewalCalls applicantUserId={applicantUserId} requestId={InsuranceRequestId} />
            <CrmCallHistoryModal newRenewalCall={true} usrUserID={applicantUserId} requestId={InsuranceRequestId} />
        </Card>

    );
}


